import Icon from './Icon';
import { articles } from '../constants/content';

const icons = ['radar', 'globe', 'family'];

export default function Insights() {
  return (
    <section className="section" id="insights">
      <div className="container">
        <div className="sec-head sec-head--center">
          <p className="kicker">Security Insights</p>
          <h2 className="sec-title">Stay ahead of the latest threats</h2>
          <p className="sec-lead">
            Plain-English guidance from our support desk on the scams and settings that matter right
            now.
          </p>
        </div>

        <div className="article-grid">
          {articles.map((article, i) => (
            <article key={article.title} className="article">
              <div className={`article__art article__art--${i + 1}`}>
                <Icon name={icons[i]} size={40} strokeWidth={1.3} />
              </div>
              <div className="article__body">
                <p className="article__kicker">{article.kicker}</p>
                <h3 className="article__title">{article.title}</h3>
                <p className="article__text">{article.text}</p>
                <p className="article__read">{article.read}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
